<template>
    <span v-on:click="onClick" :class="{ 'icon-checkbox': true, checked: checked }">
        <img v-if="!checked" :src="'/img/logos/' + data.icon_white" />
        <img v-if="checked" :src="'/img/logos/' + data.icon_color" />
    </span>
</template>

<script>
    import Router from '../../../routing';

    export default {
        name: "IconCheckbox",
        props: ["index", "data", "value", "checked"],
        data: function(){
            return {
                baseUrl: Router.getBaseUrl()
            }
        },
        methods: {
            onClick: function () {
                this.$emit('checked', this.index);
            }
        }
    }
</script>

<style scoped lang="scss">
    .icon-checkbox {
        display: inline-block;
        border: 1px solid white;

        border-radius: 5px;

        float: left;

        width: calc(25% - 12px);
        padding-top: calc(25% - 12px);

        margin-left: 5px;
        margin-right: 5px;

        position: relative;

        margin-bottom: 7px;

        img {
            max-width: 60%;
            max-height: 60%;
            position: absolute;

            left: 50%;
            top: 50%;
            transform: translateX(-50%) translateY(-50%);
        }

        &.checked {
            background-color: white;
        }
    }
</style>